import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {concatMap, map, switchMap, withLatestFrom} from 'rxjs/operators';
import {AppState} from '@store/state/app.state';
import {Store} from '@ngrx/store';
import {UserService} from '@iw-shop//user/services/user.service';
import {CustomerService} from '@iw-shop/customer/services/customer.service';
import {MappedCustomer} from '@store/state/user.state';
import * as UserActions from '@store/actions/user.action';
import * as StorageActions from '@store/actions/storage.action';
import * as GlobalActions from '@store//actions/global.actions';
import * as AuthenticationActions from '@store/actions/authentication.action';
import {

    userId
} from '@store/actions/storage.action';
import {of} from 'rxjs';
import {selectCustomer} from '@store/actions/storage.action';
import {ShoppingCartService} from "@iw-shop/shopping-cart/services/shopping-cart.service";
import {HTTPQueue} from "@iw-shop/core/classes/http-queue";

@Injectable()
export class UserEffects {

    constructor(
        private actions$: Actions,
        private store: Store<AppState>,
        private httpQueue: HTTPQueue,
        private userService: UserService,
        private customerService: CustomerService,
        private shoppingCartService: ShoppingCartService) {
    }


    setUser$ = createEffect(() => this.actions$.pipe(
            ofType(UserActions.setUser),
            concatMap((action) => this.userService.getUser(action.userId)
                .pipe(
                    map(r => {
                        if (r.result?.users?.data[0]) {
                            return UserActions.setUserSuccess(
                                {
                                    user: {
                                        id: r.result?.users?.data[0].id,
                                        username: r.result?.users?.data[0].username,
                                        email: r.result?.users?.data[0].email,
                                        shopAccessForCustomers: r.result?.users?.data[0].shopAccessForCustomers
                                    }
                                }
                            )
                        } else {
                            return AuthenticationActions.logout();
                        }
                    })
                )
            ),
        )
    );


    setUserSuccess = createEffect(() => this.actions$.pipe(
        ofType(UserActions.setUserSuccess),
        map((action) => {
            this.store.dispatch(userId({userId: action.user.id}));
            let customerIds: string[] = [];
            action.user.shopAccessForCustomers.map(
                customer => {
                    customerIds.push(customer.customerId);
                }
            )
            if (customerIds.length > 0) {
                return UserActions.setMappedCustomers({customerIds});
            }
            return GlobalActions.setNotification({
                notification: 'In Ihrem User-Account sind keine Kunden zugeordnet.',
                notificationType: 'error'
            });
        })
    ));

    setMappedCustomers$ = createEffect(() => this.actions$.pipe(
        ofType(UserActions.setMappedCustomers),
        concatMap((action) => this.customerService.getCustomers(action.customerIds)
            .pipe(
                map(r => {
                    if (r.result?.customers?.data) {
                        let mappedCustomers: MappedCustomer[] = [];
                        r.result?.customers?.data.map(
                            customer => {
                                mappedCustomers.push(new MappedCustomer(customer))
                            }
                        )
                        return UserActions.setMappedCustomersSuccess(
                            {mappedCustomers});
                    }
                    return UserActions.setMappedCustomersFailure();
                })
            )
        )
    ));

    refreshMappedCustomer$ = createEffect(() => this.actions$.pipe(
        ofType(UserActions.refreshMappedCustomer),
        concatMap((action) => this.customerService.getCustomers([action.customerId])
            .pipe(
                map(r => {
                    if (r.result?.customers?.data) {
                        return UserActions.refreshMappedCustomerSuccess({
                            mappedCustomer: {
                                ...r.result.customers.data[0]
                            }
                        });
                    }
                    return UserActions.refreshMappedCustomerFailure();
                })
            )
        )
    ));

    setMappedCustomersSuccess$ = createEffect(() => this.actions$.pipe(
        ofType(UserActions.setMappedCustomersSuccess),
        map((action) => {
            if (action.mappedCustomers.length == 1) {
                this.store.dispatch(selectCustomer({customerId: action.mappedCustomers[0].id || ''}));
            }
        })
    ), {dispatch: false});


    resetUser$ = createEffect(() => this.actions$.pipe(
        ofType(UserActions.resetUser),
        map((action) => {
            return StorageActions.deselectCustomer();
        })
    ));

    updateCustomerArticleFavorites = createEffect(() => this.actions$.pipe(
        ofType(UserActions.setCustomerArticleFavorites, UserActions.addCustomerArticleFavorite, UserActions.removeCustomerArticleFavorite),
        switchMap(a =>
            of(a)
                .pipe(
                    withLatestFrom(this.store.select(state => state.user.mappedCustomers?.filter(res => res.id === a.customerId)[0])),
                    concatMap(([a, s]) => this.customerService.updateFavorites(s?.id || '', s?.favoritesList || [])),
                    map(r => {
                            if (r.result?.customers.updated) {
                                return UserActions.updateCustomerArticleFavoritesSuccess();
                            } else {
                                return UserActions.updateCustomerArticleFavoritesFailure();
                            }

                        }
                    )
                ))
    ));

    updateCustomerArticleStocks = createEffect(() => this.actions$.pipe(
        ofType(UserActions.setCustomerArticleStocks),
        switchMap(a =>
            of(a)
                .pipe(
                    withLatestFrom(this.store.select(state => state.user.mappedCustomers?.filter(res => res.id === a.customerId)[0])),
                    concatMap(([a, s]) => this.customerService.updateArticleStocks(s?.id || '', s?.articleStocks || [])),
                    map(r => {
                            if (r.result?.customers.updated) {
                                return UserActions.updateCustomerArticleStocksSuccess();
                            } else {
                                return UserActions.updateCustomerArticleStocksFailure();
                            }

                        }
                    )
                ))
    ));

}
